import { atom } from 'jotai'

export type ConnectionStatus =
  'CONNECTED' | 'DISCONNECTED' | 'RECONNECTING' | 'SUSPENDED'

export const connectionStatusAtom = atom<ConnectionStatus>('CONNECTED')

/**
 * Epoch-ms timestamp of the last heartbeat (server Ping) received over the
 * realtime WebSocket, or null if none has arrived this session. Written in
 * the React tree by useWebSocketHeartbeat (so it lands in the JotaiProvider
 * store), read by the status panel to show connection liveness. This is a
 * liveness signal, not a round-trip latency — the heartbeat is
 * server-initiated.
 */
export const lastWebSocketPingAtom = atom<number | null>(null)

export type ConnectionEventKind =
  | 'online'
  | 'offline'
  | 'ws-connected'
  | 'ws-reconnecting'
  | 'ws-suspended'
  | 'ws-disconnected'

export interface ConnectionEvent {
  /** Epoch-ms when the transition was observed. */
  at: number
  kind: ConnectionEventKind
}

// Cap the in-memory log so it can't grow unbounded over a long session.
export const MAX_CONNECTION_EVENTS = 25

/**
 * A short rolling log of recent connection transitions (network + realtime
 * socket), newest last. Diagnostic-only and non-sensitive — it carries event
 * kinds and timestamps, never message content or identifiers. Populated in
 * the React tree by useConnectionEventLog; surfaced in the status panel and
 * the copied diagnostics so "it feels flaky" becomes a concrete sequence.
 */
export const connectionEventsAtom = atom<ConnectionEvent[]>([])
